import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { LogOut, Menu } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';
import LanguageSelector from '../components/LanguageSelector';
import ThemeToggle from '../components/ThemeToggle';
import MobileBottomNav from '../components/MobileBottomNav';
import MobileMenu from '../components/MobileMenu';
import SiteFooter from '../components/SiteFooter';
import ToolSidebar from '../components/ToolSidebar';
import ResumeBuilder from '../components/ResumeBuilder';
import '../styles/StampMakerPage.css';
import '../styles/HomePage.css';
import '../styles/ResumeBuilder.css';

const LOGO_DARK = "https://customer-assets.emergentagent.com/job_422444ca-8f0f-4ebc-8f78-bee66ce7f723/artifacts/qo6wuzuf_REGISTAN%20LOGO.png";
const LOGO_LIGHT = "https://customer-assets.emergentagent.com/job_9d222022-9462-4aac-aca8-59da15d4f381/artifacts/tueqptuk_registan%20logo.png";

const ResumeEditorPage = () => {
  const navigate = useNavigate();
  const { user, logout, isAuthenticated } = useAuth();
  const { t } = useLanguage();
  const { theme } = useTheme();
  const currentLogo = theme === 'light' ? LOGO_LIGHT : LOGO_DARK;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="stampmaker-page" data-testid="resume-editor-page">
      <Helmet>
        <title>{t('rbFormTitle') || 'Resume Builder'} | Registan Tourism</title>
      </Helmet>

      <header className="dark-header">
        <div className="header-left">
          <div className="header-logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
            <img src={currentLogo} alt="Registan Tourism" className="logo-img" />
          </div>
          <LanguageSelector />
          <ThemeToggle />
        </div>
        {isAuthenticated ? (
          <div className="header-user-menu">
            <button className="btn-user-profile" onClick={() => navigate('/dashboard')}>
              <div className="user-avatar-small">{user?.name?.charAt(0)?.toUpperCase()}</div>
              <span>{user?.name}</span>
            </button>
            <button className="btn-logout-header" onClick={logout} title="Logout">
              <LogOut size={20} />
            </button>
          </div>
        ) : (
          <div className="header-auth-buttons">
            <button className="btn-secondary btn-login" onClick={() => navigate('/login')}>{t('login') || 'Login'}</button>
            <button className="btn-primary btn-signup" onClick={() => navigate('/register')}>{t('signUp') || 'SIGN UP'}</button>
          </div>
        )}
        <button className="mobile-menu-toggle" onClick={() => setIsMobileMenuOpen(true)}>
          <Menu size={24} />
        </button>
      </header>
      <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />

      <div className="tool-page-layout">
        <ToolSidebar />
        <main className="tool-page-content" style={{ padding: '20px' }}>
          <ResumeBuilder />
        </main>
      </div>

      <SiteFooter />
      <MobileBottomNav />
    </div>
  );
};

export default ResumeEditorPage;
